import { render, staticRenderFns } from "./register-form-select-currency.vue?vue&type=template&id=e22a3ae8&"
import script from "./register-form-select-currency.vue?vue&type=script&lang=js&"
export * from "./register-form-select-currency.vue?vue&type=script&lang=js&"
import style0 from "./register-form-select-currency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports